export default {
  // 获取字典label
  findDict: state => (type, value) => {
    const dict = state.dict.dicts[type];
    const status = dict && dict.find(el => ~~el.value === ~~value);
    return status ? status.label : ``;
  },
};
